import { Button } from 'antd'
import { ButtonProps } from 'antd/es/button/button'
import clsx from 'clsx'

import styles from './pure-button.module.scss'

export const PureButton = ({ className, ...props }: ButtonProps) => {
  return (
    <Button
      className={clsx(
        {
          [styles.pureButton]: !props.type,
        },
        className,
      )}
      size="small"
      {...props}
    ></Button>
  )
}
